import type { TQuestionPoolStatus } from './question-pool.types'

export const questionPoolEndpoints = {
  list: '/question-pools',
} as const

export const questionPoolListKey = (
  status?: TQuestionPoolStatus
): readonly ['questionPoolList', TQuestionPoolStatus | 'ALL'] => [
  'questionPoolList',
  status ?? 'ALL',
]
